import React, { PureComponent } from 'react';

import DirectoryPath from './directory-path';
import { DirectoryHeader, FilterMessage } from './directory.style';

const Header = DirectoryHeader.withComponent(DirectoryPath);

type FilterHeaderProps = {
  message: React.ReactNode;
};

export default class FilterHeader extends PureComponent<FilterHeaderProps> {
  render() {
    return (
      <Header>
        <FilterMessage>{this.props.message}</FilterMessage>
      </Header>
    );
  }
}
